import { createReducer, on } from "@ngrx/store";
import { LocationPartnerStateInterface } from "./location-partnerState.interface";
import { ObjectiveTypeEnum } from "src/app/shared/enum/objectives";
import { LocationSearchMethod } from "src/app/shared/enum/locationSearchMethod";
import {
  resultMainStaticsForLocationPartner,
  invokeLocationPartnerReview,
  resultLocationPartnerReview,
} from "./actions/get-impressions.actions";
import {
  invokeLocationPartnerFilter,
  getLocationPartnersSuccess,
  setLocationPartnersCompanyNames,
  invokeFilterLocationsToCreateCampaign,
  locationPartnersToCreateCampaignSuccess,
  setLocationPartnersByCompanyNames,
  resultLPInfo,
  invokeLocationPartnerImpressionsFilter,
  setLocationPartnerImpressions,
  setLocationPartnerPrices,
  invokeLocationPartnerPricesFilter,
} from "./actions/get-locations.actions";
import {
  updateLocationPartnerSuccess,
  updateLocationPartnerAccountSuccess,
  resultCalculateAndUpdateViewsAverage,
  invokeCalculateAndUpdateViewAverage,
  invokeUpdateViewsAverageManually,
  resultUpdateViewsAverage,
} from "./actions/update.actions";
import {
  calculateTotalLPCostByCampanyNames,
  createLocationPartnerSuccess,
  invokePricingByCompanyName,
  setPricingByCompanyName,
  resultLocationPartnerByRegion,
  selectedLPs,
  deleteLocationPartnerSuccess,
  resultGrantPremiumAccessForLP,
  invokeGrantPremiumAccessForLP,
  resultSuccess,
  resultLocationPartnerAdvertisingCampignFilter,
  invokeAdvertisingCampaignRemunerationForLocationPartner,
  invokeCalculateTotalLPCostByCampanyNames,
  saveSelectedLocationsForMap,
  resultUpdateApiKey,
  invokeUpdateApiKey,
  invokeRemunerationDetails,
  resultRemunerationDetails,
  assignLPtoFranchiseSuccess,
  invokeDeleteLocationPartner,
  invokeCreateLocationPartner,
  invokeCalculateTotalLPPriceByCampanyNames,
  calculateTotalLPPriceByCampanyNames,
} from "./location-partner.action";

export const initialState: Readonly<LocationPartnerStateInterface> = {
  mainDashboard: null,
  loading: false,
  companyNames: [],
  locationPartnersToCreateCampaignResult: [],
  locationPartnersResult: {
    count: 0,
    locationPartners: [],
  },
  locationPartnerFilter: {
    zoneNames: [],
    companyName: null,
    searchCompanyName: null,
    companyNames: [],
    regions: [],
    showingAdmin: null,
    showingAdvertiser: null,
    partnerStatus: null,
    startDate: null,
    endDate: null,
    tags: [],
    subcategories: [],
    sortName: null,
    isAscending: true,
    pager: {
      pageNumber: 1,
      pageSize: 10,
    },
    isPaid: null,
  },
  locationPartnersByCompanyNames: null,
  allLocationPartners: null,
  successMessage: null,
  locationPartnersToCreateCampaignFilter: {
    locationsSearchMethod: LocationSearchMethod.LOCATION_PARTNER,
    regions: [],
    zones: [],
    subCategories: [],
    tags: [],
  },
  calculatePrice: {
    calculationMethod: LocationSearchMethod.LOCATION_PARTNER,
    names: [],
    objectiveName: ObjectiveTypeEnum.BRAND_AWARENESS_AND_REACH,
    startDate: null,
    endDate: null,
    checkDates: true,
  },
  totalPriceWithDiscount: {
    discount: 100,
    totalPricePerDay: [],
  },
  locationPartner: null,
  resultMainStaticsForLP: null,
  pricingByCompanyName: null,
  lpInfo: null,
  lastWeekReviewLP: null,
  lps: null,
  impressionsFilter: {
    regionNames: [],
    companyName: null,
    zoneNames: [],
    pager: {
      pageNumber: 1,
      pageSize: 10,
    },
  },
  impressionsResult: {
    count: 0,
    locations: [],
  },
  pricesFilter: {
    companyName: null,
    pager: {
      pageNumber: 1,
      pageSize: 10,
    },
    isShowAdvertiser : true
  },
  pricesResult: {
    count: 0,
    locations: [],
  },
  selectedLps: null,
  averageViewsUpdateResult: null,
  grantPremiumAccess: null,
  advertisingCampaignsPaymentLP: null,
  loadingLocationCampaigns: true,
  loadingViews: false,
  locations: null,
  loadingViewsManually: false,
  apiKeySuccess: null,

  remunerationDetails: null,
  loadingRemuneration: true
};

export const LocationPartnerReducer = createReducer(
  initialState,
  on(invokeLocationPartnerFilter, (state, { locationPartnerFilter }) => ({
    ...state,
    locationPartnerFilter: locationPartnerFilter
  })),
  on(getLocationPartnersSuccess, (state, { locationPartnersResult }) => ({
    ...state,
    locationPartnersResult: locationPartnersResult,
    loading: false,
  })),
  on(setLocationPartnersCompanyNames, (state, { companyNames }) => ({
    ...state,
    companyNames: companyNames,
    loading: false,
  })),
  //Filter location partners to create advertising campaign
  on(
    invokeFilterLocationsToCreateCampaign,
    (
      state,
      {
        filterLocationPartnersToCreateCampaign:
          locationPartnersToCreateCampaign,
      }
    ) => ({
      ...state,
      locationPartnersToCreateCampaignFilter: locationPartnersToCreateCampaign,
      loading: false,
    })
  ),
  on(
    locationPartnersToCreateCampaignSuccess,
    (state, { locationPartnersToCreateCampaign }) => ({
      ...state,
      locationPartnersToCreateCampaignResult: locationPartnersToCreateCampaign,
      loading: false,
    })
  ),
  on(invokeCalculateTotalLPCostByCampanyNames, (state, { calculatePrice }) => ({
    ...state,
    loadingViews: true,
  })),
  on(invokeCalculateTotalLPPriceByCampanyNames, (state, { calculatePrice }) => ({
    ...state,
    loadingViews: true,
  })),
  on(
    calculateTotalLPCostByCampanyNames,
    (state, { totalPriceWithDiscount }) => ({
      ...state,
      totalPriceWithDiscount: totalPriceWithDiscount,
      loadingViews: false,
    })
  ),
  on(
    calculateTotalLPPriceByCampanyNames,
    (state, { totalPriceWithDiscount }) => ({
      ...state,
      totalPriceWithDiscount: totalPriceWithDiscount,
      loadingViews: false,
    })
  ),
  on(invokeCreateLocationPartner, (state) => ({
    ...state,
    loading: true
  })),
  on(createLocationPartnerSuccess, (state, { successMessage }) => ({
    ...state,
    loading: false,
    successMessage: successMessage,
  })),
  on(updateLocationPartnerSuccess, (state, { successMessage }) => ({
    ...state,
    successMessage: successMessage,
    loading: false
  })),

  on(setLocationPartnersByCompanyNames, (state, { locationPartners }) => ({
    ...state,
    locationPartnersByCompanyNames: locationPartners,
  })),
  on(
    resultMainStaticsForLocationPartner,
    (state, { resultMainStaticsForLP }) => ({
      ...state,
      resultMainStaticsForLP: resultMainStaticsForLP,
    })
  ),
  on(invokePricingByCompanyName, (state, { companyName }) => ({
    ...state,
    loading: true,
  })),
  on(setPricingByCompanyName, (state, { pricing }) => ({
    ...state,
    pricingByCompanyName: pricing,
    loading: false,
  })),
  on(resultLPInfo, (state, { lpInfo }) => ({
    ...state,
    lpInfo: lpInfo,
    loading: false,
  })),
  on(invokeLocationPartnerReview, (state) => ({
    ...state,
    loading: true,
  })),
  on(resultLocationPartnerReview, (state, { lastWeekReviewLP }) => ({
    ...state,
    lastWeekReviewLP: lastWeekReviewLP,
    loading: false,
  })),
  on(updateLocationPartnerAccountSuccess, (state, { successMessage }) => ({
    ...state,
    successMessage: successMessage,
    loading: false
  })),

  on(resultLocationPartnerByRegion, (state, { lps }) => ({
    ...state,
    lps: lps,
    loading: false,
  })),
  on(invokeLocationPartnerImpressionsFilter, (state, { filter }) => ({
    ...state,
    impressionsFilter: filter,
  })),
  on(invokeLocationPartnerPricesFilter, (state, { filter }) => ({
    ...state,
    loading: true,
    pricesFilter: filter,
  })),
  on(setLocationPartnerImpressions, (state, { result }) => ({
    ...state,
    loading: false,
    impressionsResult: result,
  })),
  on(setLocationPartnerPrices, (state, { result }) => ({
    ...state,
    loading: false,
    pricesResult: result,
  })),
  on(updateLocationPartnerAccountSuccess, (state, { successMessage }) => ({
    ...state,
    successMessage: successMessage,
    loading: false
  })),
  on(selectedLPs, (state, { selectedLps }) => ({
    ...state,
    selectedLps: selectedLps,
  })),
  //Impressions
  on(
    invokeCalculateAndUpdateViewAverage,
    (state, { calculateAverageViews, sendMail }) => ({
      ...state,
      loadingViews: true,
    })
  ),
  on(resultCalculateAndUpdateViewsAverage, (state, { successMessage }) => ({
    ...state,
    loadingViews: false,
    averageViewsUpdateResult: successMessage,
    loading: false
  })),
  on (invokeDeleteLocationPartner, (state, { email }) => ({
    ...state,
    loading: true
  })),
  on(deleteLocationPartnerSuccess, (state, { successMessage }) => ({
    ...state,
    loading: false,
    successMessage: successMessage,
  })),
  on(invokeGrantPremiumAccessForLP, (state) => ({
    ...state,
    loading: true,
  })),
  on(resultGrantPremiumAccessForLP, (state, { successMessage }) => ({
    ...state,
    successMessage: successMessage,
    loading: false,
  })),
  on(resultSuccess, (state, { successMessage }) => ({
    ...state,
    successMessage: successMessage,
    loading: false
  })),
  on(invokeAdvertisingCampaignRemunerationForLocationPartner, (state) => ({
    ...state,
    loadingLocationCampaigns: true,
  })),
  on(
    resultLocationPartnerAdvertisingCampignFilter,
    (state, { advertisingCampaignsPaymentLP }) => ({
      ...state,
      advertisingCampaignsPaymentLP: advertisingCampaignsPaymentLP,
      loadingLocationCampaigns: false,
    })
  ),
  on(saveSelectedLocationsForMap, (state, { locations }) => ({
    ...state,
    locations: locations,
  })),

  on(invokeUpdateViewsAverageManually, (state, { updateViewsAverage }) => ({
    ...state,
    loadingViewsManually: true,
  })),
  on(resultUpdateViewsAverage, (state, { successMessage }) => ({
    ...state,
    loadingViewsManually: false,
    successMessage: successMessage,
    loading: false
  })),

  on(invokeUpdateApiKey, (state, { apiKey, email }) => ({
    ...state,
    loadingAPIKey: true,
  })),

  on(resultUpdateApiKey, (state, { apiKeySuccess }) => ({
    ...state,
    loadingAPIKey: false,
    apiKeySuccess: apiKeySuccess,
  })),

  on(invokeRemunerationDetails, (state, { filter, refreshCache }) => ({
    ...state,
    loadingRemuneration: true,
  })),

  on(resultRemunerationDetails, (state, { remunerationDetails }) => ({
    ...state,
    remunerationDetails,
    loadingRemuneration: false,
  })),
  
  on(assignLPtoFranchiseSuccess, (state, { successMessage }) => ({
    ...state,
    successMessage: successMessage,
    loading: false
  })),
);
